var components
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  var m0 = _vm.theme() || ""
  var m1 = _vm.theme()
  if (!_vm._isMounted) {
    _vm.e0 = function ($event) {
      _vm.is_login = 1
    }
    _vm.e1 = function ($event) {
      _vm.is_login = 2
    }
    _vm.e2 = function ($event) {
      _vm.is_login = 1
    }
    _vm.e3 = function ($event) {
      _vm.is_login = 0
    }
    _vm.e4 = function ($event) {
      _vm.isRead = !_vm.isRead
    }
  }
  _vm.$mp.data = Object.assign(
    {},
    {
      $root: {
        m0: m0,
        m1: m1,
      },
    }
  )
}
var recyclableRender = false
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns, recyclableRender, components }